// extracted by mini-css-extract-plugin
module.exports = {"container":"ii","image":"ij","title":"ik","date":"il"};